module.exports = {"success":true,"message":"string","code":"string","result":{"nickname":"Test 1","correctAns":"2","points":"100","maskedEmail":"tabxxx@visa.com","time":"00:01:00"}}


//////////////////
// WEBPACK FOOTER
// ./src/mocks/getResultMock.json
// module id = 474
// module chunks = 0